<!-- New Agency -->
<section>
    <div class="container content-box">

        <!-- Form -->
        <form name="form" class="" (submit)="f.form.valid && onSubmit()" #f="ngForm" novalidate>

            <!-- Header -->
            <h1 class="text-center">Enroll a New Agency</h1>
            <p class="text-center">Fill in this form and click "Submit" to enroll a new Agency.</p>
            <hr>

            <!-- Agency Name -->
            <div class="col-md-12">
                <div class="row mt-2">
                    <div class="col-md-12">
                        <label class="required-field">Agency's Name</label>
                        <input type="agencyName" id="agencyName" class="form-control mb-2" placeholder="Agency Name" name="agencyName" required [(ngModel)]="agency.agencyName" #agencyName="ngModel" [ngClass]="{ 'is-invalid': f.submitted && agencyName.invalid }">

                        <!-- Invalid Agency Name -->
                        <div *ngIf="f.submitted && agencyName.invalid" class="invalid-feedback">
                            <div class="mb-1 text-center" *ngIf="agencyName.errors!.required">Agency name is required</div>
                            <div class="mb-1 text-center" *ngIf="agencyName.errors!.agencyName">Must be a valid agency name</div>
                        </div>
                    </div>
                </div>

                <!-- Coordinator Name -->
                <div class="row mt-2">
                    <div class="col-md-12">
                        <label class="required-field">Name of the Agency's Coordinator</label>
                        <input type="coordinatorName" id="coordinatorName" class="form-control mb-2" placeholder="Coordinator's Name" name="coordinatorName" required [(ngModel)]="agency.coordinatorName" #coordinatorName="ngModel" [ngClass]="{ 'is-invalid': f.submitted && coordinatorName.invalid }">

                        <!-- Invalid Coordinator Name-->
                        <div *ngIf="f.submitted && coordinatorName.invalid" class="invalid-feedback">
                            <div class="mb-1 text-center" *ngIf="coordinatorName.errors!.required">Coordinator name is required</div>
                            <div class="mb-1 text-center" *ngIf="coordinatorName.errors!.coordinatorName">Must be a valid coordinator name</div>
                        </div>
                    </div>
                </div>

                <!-- Email -->
                <div class="row mt-2">
                    <div class="col-md-12">
                        <label class="required-field">Agency's Email</label>
                        <input type="email" id="email" class="form-control mb-2" placeholder="Email" name="email" email required [(ngModel)]="agency.email" #email="ngModel" [ngClass]="{ 'is-invalid': f.submitted && email.invalid }">

                        <!-- Invalid email-->
                        <div *ngIf="f.submitted && email.invalid" class="invalid-feedback">
                            <div class="mb-1 text-center" *ngIf="email.errors!.required">Email is required</div>
                            <div class="mb-1 text-center" *ngIf="email.errors!.email">Must be a valid email</div>
                        </div>
                    </div>
                </div>

                <!-- Phone Number -->
                <div class="row mt-2">
                    <div class="col-md-12">
                        <label class="required-field">Agency's Phone Number</label>
                        <input type="phone" id="phone" class="form-control mb-2" placeholder="Phone Number" name="phone" required [(ngModel)]="agency.phone" [pattern]="phonePattern" #uname="ngModel" #phone="ngModel" [ngClass]="{ 'is-invalid': f.submitted && phone.invalid }">

                        <!-- Invalid Phone Number-->
                        <div *ngIf="f.submitted && phone.invalid || f.submitted && uname.errors?.pattern" class="invalid-feedback">
                            <div class="mb-1 text-center" *ngIf="phone.errors!.required">Phone number is required</div>
                            <div class="mb-1 text-center" *ngIf="uname.errors?.pattern">Must be a valid phone number</div>
                        </div>
                    </div>
                </div>

                <!-- Street Address -->
                <div class="row mt-2">
                  <div class="col-md-12">
                      <label>Agency's Street Address 1</label>
                      <input type="text" id="streetAddress" class="form-control mb-2" [(ngModel)]="agency.streetAddress" name="streetAddress" #streetAddress="ngModel" [ngClass]="{ 'is-invalid': f.submitted && streetAddress.invalid }">

                      <!-- Invalid Street Address 1 -->
                      <div *ngIf="f.submitted && streetAddress.invalid" class="invalid-feedback">
                      </div>
                  </div>
                </div>

                <!-- Street Address 2 -->
                <div class="row mt-2">
                  <div class="col-md-12">
                      <label>Agency's Street Address 2</label>
                      <input type="text" id="secondary" class="form-control mb-2" [(ngModel)]="agency.secondary" name="secondary" #secondary="ngModel" [ngClass]="{ 'is-invalid': f.submitted && secondary.invalid }">

                      <!-- Invalid Street Address 2 -->
                      <div *ngIf="f.submitted && secondary.invalid" class="invalid-feedback">
                      </div>
                  </div>
                </div>

                <!-- City -->
                <div class="row mt-2">
                  <div class="col-md-5">
                      <label>City</label>
                      <input type="text" id="city" class="form-control mb-2" [(ngModel)]="agency.city" name="city" #city="ngModel" [ngClass]="{ 'is-invalid': f.submitted && city.invalid }">

                      <!-- Invalid -->
                      <div *ngIf="f.submitted && city.invalid" class="invalid-feedback">
                      </div>
                  </div>

                  <!-- State -->
                  <div class="col-md-3">
                      <label>State</label>
                      <select name="state" id="state" class="form-control mb-2" placeholder="--" [(ngModel)]="agency.state" name="state" #state="ngModel" [ngClass]="{ 'is-invalid': f.submitted && state.invalid }">
                        <option value="" selected="selected" disabled="disabled">--</option>
                        <option value="AL">Alabama</option>
                        <option value="AK">Alaska</option>
                        <option value="AZ">Arizona</option>
                        <option value="AR">Arkansas</option>
                        <option value="CA">California</option>
                        <option value="CO">Colorado</option>
                        <option value="CT">Connecticut</option>
                        <option value="DE">Delaware</option>
                        <option value="DC">District Of Columbia</option>
                        <option value="FL">Florida</option>
                        <option value="GA">Georgia</option>
                        <option value="HI">Hawaii</option>
                        <option value="ID">Idaho</option>
                        <option value="IL">Illinois</option>
                        <option value="IN">Indiana</option>
                        <option value="IA">Iowa</option>
                        <option value="KS">Kansas</option>
                        <option value="KY">Kentucky</option>
                        <option value="LA">Louisiana</option>
                        <option value="ME">Maine</option>
                        <option value="MD">Maryland</option>
                        <option value="MA">Massachusetts</option>
                        <option value="MI">Michigan</option>
                        <option value="MN">Minnesota</option>
                        <option value="MS">Mississippi</option>
                        <option value="MO">Missouri</option>
                        <option value="MT">Montana</option>
                        <option value="NE">Nebraska</option>
                        <option value="NV">Nevada</option>
                        <option value="NH">New Hampshire</option>
                        <option value="NJ">New Jersey</option>
                        <option value="NM">New Mexico</option>
                        <option value="NY">New York</option>
                        <option value="NC">North Carolina</option>
                        <option value="ND">North Dakota</option>
                        <option value="OH">Ohio</option>
                        <option value="OK">Oklahoma</option>
                        <option value="OR">Oregon</option>
                        <option value="PA">Pennsylvania</option>
                        <option value="RI">Rhode Island</option>
                        <option value="SC">South Carolina</option>
                        <option value="SD">South Dakota</option>
                        <option value="TN">Tennessee</option>
                        <option value="TX">Texas</option>
                        <option value="UT">Utah</option>
                        <option value="VT">Vermont</option>
                        <option value="VA">Virginia</option>
                        <option value="WA">Washington</option>
                        <option value="WV">West Virginia</option>
                        <option value="WI">Wisconsin</option>
                        <option value="WY">Wyoming</option>
                    </select>

                      <!-- Invalid -->
                      <div *ngIf="f.submitted && state.invalid" class="invalid-feedback">
                      </div>
                  </div>

                  <!-- Zip Code -->
                  <div class="col-md-4">
                      <label>Zip Code</label>
                      <input type="text" id="zipCode" class="form-control mb-2" placeholder="#####" [(ngModel)]="agency.zipCode" name="zipCode" #zipCode="ngModel" [ngClass]="{ 'is-invalid': f.submitted && zipCode.invalid }">

                      <!-- Invalid -->
                      <div *ngIf="f.submitted && zipCode.invalid" class="invalid-feedback">
                      </div>
                  </div>
                </div>

                <!-- Row Input -->
                <div class="row mt-2">

                  <!-- County -->
                  <div class="col-md-5">
                    <label>County</label>
                    <input type="text" id="county" class="form-control mb-2" [(ngModel)]="agency.county" name="county" #county="ngModel" [ngClass]="{ 'is-invalid': f.submitted && county.invalid }">

                    <!-- Invalid -->
                    <div *ngIf="f.submitted && county.invalid" class="invalid-feedback">
                    </div>
                  </div>
                </div>
            </div>

            <!-- Submit button -->
            <div class="text-center">
                <button type="submit" class="my-4 btn">Submit</button>
            </div>
        </form>
    </div>
</section>
